<template>
  <div id="app">
    <onHead @urerId="getCreateId" :getInfo="getInfo" @Collapse="Collapse"></onHead>
    <div class="disBox">
      <Navtab :tabSt="tabSt" :getFun="getFun" @getUrl="getUrl" @getTag="getTag" @getMenu="getMenu" :isCollapse="isCollapse"></Navtab>
      <transition>
        <router-view @gettabSt="gettabSt" @getAjax="getAjax" :createId="createId" @gettabStINfo="gettabStINfo"></router-view>
      </transition>
    </div>
    <!--<transition>-->
      <!--<router-view></router-view>-->
    <!--</transition>-->
  </div>
</template>

<script>
  import Navtab from './components/Navtab'
  import onHead from './components/onHead'
export default {
  name: 'App',
  components: {
    Navtab,
    onHead,
  },
  data(){
    return{
      tabSt: '',
      createId: '',
      getInfo:'',
      navUrl: '',
      tagName: '',
      menu: '',
      getFun: '',
      isCollapse: false,
    }
  },
  watch: {
    '$route' (to, from) {
      document.title = this.$route.meta.title || this.$route.name;
    }
  },
  methods:{
    gettabSt(e){
      this.tabSt=e;
    },
    getUrl(e){
      this.navUrl=e;
    },
    getTag(e){
      this.tagName=e;
    },
    getMenu(e){
      this.menu=e;
    },
    getCreateId(e){
      this.createId=e;
    },
    gettabStINfo(e){
      this.getInfo = e
    },
    getAjax(e){
      this.getFun=e;
    },
    Collapse() {
      this.isCollapse = !this.isCollapse;
    },
  },
}
</script>

<style>
*{
  margin: 0;
  padding: 0;
}
body,html{
  min-height: 100vh;
  width: 100%;
}
#app {
  min-height: 100vh;
  width: 100%;
  font-family: 'MicrosoftYaHei', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
  .disBox{
    display: flex;
  }
  .v-modal{
  z-index: 1 !important;
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue